import React, { useContext, useState } from "react";
import ReactDOM from "react-dom";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AuthService from "../../services/auth.service";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import moment from "moment";
import { API_URL } from "../../utilities/url";
import BroadcastChart from "./component/broadcastChart";
import { Button, Spinner } from "react-bootstrap";
import storage from "../../services/storage";
import CryptoJS from "crypto-js";
import { FaCog, FaTrash } from "react-icons/fa";
import { PiChartLineUpBold } from "react-icons/pi";
import { WorkspaceContext } from "../../provider/workspaceContext";
import ModalReport from "./component/reportAnayzeModal";
import axios from "axios";
import { format_number } from "../../utilities/ext-function";
import authService from "../../services/auth.service";

var $ = require("jquery");

const Broadcast = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeFilter, setActiveFilter] = useState("All");
  const { workspace, setWorkspace } = useContext(WorkspaceContext);
  const [isWorkspaceLoaded, setIsWorkspaceLoaded] = useState(false);
  const [modalReport, setModalReport] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);

  useEffect(() => {
    const encryptedWS = storage.get("wrs");
    if (encryptedWS) {
      try {
        const decryptWS = CryptoJS.AES.decrypt(encryptedWS, "wrs").toString(
          CryptoJS.enc.Utf8
        );

        if (decryptWS) {
          const parsedWorkspace = JSON.parse(decryptWS);
          setWorkspace(parsedWorkspace);
        } else {
          console.warn("Dekripsi berhasil tetapi hasilnya kosong.");
        }
      } catch (error) {
        if (error.response.data.message) {
          authService.logout();
        }
      }
    } else {
      console.warn("Tidak ada data workspace terenkripsi.");
    }

    setIsWorkspaceLoaded(true);
  }, [setWorkspace]);

  useEffect(() => {
    if (isWorkspaceLoaded && workspace) {
      getData();
    }
  }, [isWorkspaceLoaded, workspace, activeFilter]);

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
  };

  useEffect(() => {
    if (localStorage.getItem("alert")) {
      toast.success("Success Create Broadcast!", {
        position: "top-right",
        theme: "colored",
        transition: Slide,
        autoClose: 4000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: true,
        progress: undefined,
      });
      localStorage.removeItem("alert");
    } else if (localStorage.getItem("alertu")) {
      toast.success("Success Update Broadcast!", {
        position: "top-right",
        theme: "colored",
        transition: Slide,
        autoClose: 4000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: true,
        progress: undefined,
      });
      localStorage.removeItem("alertu");
    }
  }, [location.key]);

  const getData = () => {
    $("#datatables-reponsive").DataTable({
      dom:
        "<'row'<'col-sm-6'l><'col-sm-6'B>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'row'<'col-sm-5'i><'col-sm-7'p>>",
      processing: true,
      serverSide: true,
      bDestroy: true,
      ajax: {
        url: API_URL + "list-table-broadcast",
        data: function (data) {
          data.idt_user_workspace = workspace.idt_user_workspace;
          data.status = activeFilter;
        },
        type: "post",
        headers: {
          Authorization: `Bearer ${storage.get("access_token")}`,
        },
        error: function (xhr, error, code) {},
      },
      order: [[0, "desc"]],
      columnDefs: [
        {
          targets: [5],
          createdCell: function (td) {
            td.classList.add("dt-right");
          },
        },
        {
          targets: [6],
          createdCell: function (td) {
            td.classList.add("dt-center");
          },
        },
        {
          className: "dt-center",
          targets: 7,
          createdCell: (td, cellData, rowData, row, col) =>
            ReactDOM.render(
              <div className="d-grid gap-2 d-md-flex justify-content-md">
                <a
                  onClick={() => showReport(cellData)}
                  className="btn btn-sm btn-primary btn-rounded"
                  title="Report & Analyze"
                >
                  <PiChartLineUpBold size={16} />
                </a>
                <a
                  onClick={() =>
                    navigate(
                      "/broadcast/detail/" +
                        CryptoJS.AES.encrypt(JSON.stringify(cellData), "wrs")
                          .toString()
                          .replace(/\//g, "_")
                    )
                  }
                  className="btn btn-sm btn-warning btn-rounded"
                  title="Settings"
                >
                  <FaCog size={14} />
                </a>
                {/* <a
                  // onClick={() => deleteTable(cellData)}
                  className="btn btn-sm btn-tertiary btn-rounded"
                  title="Delete"
                >
                  <FaTrash />
                </a> */}
                {/* <a
                  onClick={() =>
                    navigate(
                      `/broadcast/detail/${rowData.idt_broadcast_campaign}`
                    )
                  }
                  className="btn btn-sm btn-info btn-rounded"
                  title="Settings"
                >
                  <FaCog size={14} />
                </a> */}
              </div>,
              td
            ),
        },
      ],
      columns: [
        {
          data: "ts_created",
          render: function (data, type, row) {
            var data = moment(data).format("DD-MM-YYYY");

            return data;
          },
        },
        { data: "name" },
        { data: "content_name" },
        { data: "channel" },
        {
          data: "devices_name",
          render: function (data, type, row) {
            if (!data) return "-"; // Jika data kosong, tampilkan tanda "-"

            return data
              .split(",")
              .map(
                (item) =>
                  `<span class="badge bg-info py-1 px-2 me-1">${item.trim()}</span>`
              )
              .join("");
          },
        },
        {
          data: "contacts",
          render: function (data, type, row) {
            return format_number(data);
          },
        },
        {
          data: "status",
          render: function (data, type, row) {
            if (data === "Ongoing") {
              return `<span class="badge bg-primary py-1 px-2">${data}</span>`;
            } else if (data === "Paused") {
              return `<span class="badge bg-warning py-1 px-2">${data}</span>`;
            } else if (data === "Finished") {
              return `<span class="badge bg-success py-1 px-2">${data}</span>`;
            } else if (data === "Canceled") {
              return `<span class="badge bg-danger py-1 px-2">${data}</span>`;
            } else {
              return `<span class="badge bg-primary py-1 px-2">${data}</span>`;
            }
          },
        },
        { data: "idt_broadcast_campaign" },
      ],
      initComplete: function () {
        var api = this.api();
        $("#search")
          .off(".DT")
          .on("keyup.DT", function (e) {
            api.search(this.value).draw();
          });
      },
    });
  };

  const showReport = (data) => {
    setIsLoading(true);
    axios
      .post(
        API_URL + "get-broadcast-report",
        {
          idt_broadcast_campaign: data,
        },
        {
          headers: { Authorization: `Bearer ${storage.get("access_token")}` },
        }
      )
      .then((response) => {
        if (response.data.success) {
          setIsLoading(false);
          setSelectedReport(response.data.data);
          setModalReport(true);
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };

  return (
    <div className="container-fluid p-0">
      <BroadcastChart />
      <div className="row">
        <ToastContainer />
        <div className="col-12">
          <div className="card rounded-4 shadow-lg">
            <div className="card-header rounded-4">
              <div className="d-flex justify-content-between mb-3">
                <div>
                  <h5 className="card-title mt-2">Broadcast Services</h5>
                </div>
                <div>
                  {/* <Link to="/test/add" className="btn btn-primary btn-md">
                    Tambah{" "}
                    <FiPlus
                      className="align-middle"
                      size={14}
                      strokeWidth={4}
                    />
                  </Link> */}
                </div>
              </div>
              <div className="row">
                <div className="d-flex mt-2 mb-0">
                  {/* Filter Buttons */}
                  {["All", "Ongoing", "Finished", "Paused", "Canceled"].map(
                    (filter) => (
                      <Button
                        key={filter}
                        variant={activeFilter === filter ? "orange-2" : "light"}
                        className={`me-2 ${
                          activeFilter === filter ? "text-white" : ""
                        }`}
                        onClick={() => handleFilterClick(filter)}
                      >
                        {filter}
                      </Button>
                    )
                  )}
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table
                  id="datatables-reponsive"
                  className="table table-striped table-bordered table-custome"
                >
                  <thead>
                    <tr className="text-white">
                      <th>Created At</th>
                      <th>Broadcast Name</th>
                      <th>Content Name</th>
                      <th>Channel</th>
                      <th>Device</th>
                      <th>Total Contact</th>
                      {/* <th>Start</th>
                    <th>End</th> */}
                      <th>Status</th>
                      {/* <th>PIC</th> */}
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && (
        <div className="loading-backdrop">
          <Spinner animation="border" variant="light" />
        </div>
      )}
      <ModalReport
        show={modalReport}
        handleClose={() => setModalReport(false)}
        type={null}
        data={selectedReport}
        onDeleteChange={null}
      />
    </div>
  );
};

export default Broadcast;
